import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("mtw_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { localStorage.removeItem("mtw_token"); setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const loginWithToken = (token, u) => { localStorage.setItem("mtw_token", token); setUser(u); };
  const logout = () => { localStorage.removeItem("mtw_token"); setUser(null); };

  const isStaff = user && user.kind !== "customer";
  const isCustomer = user && user.kind === "customer";

  return (
    <AuthContext.Provider value={{ user, setUser, loading, refresh, loginWithToken, logout, isStaff, isCustomer }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
